<template>
    <div v-if="!skin.lobby" class="fixed-bottom-custom">
        <div style="position: relative;">
            <img class="nav-img" :src="skin.imagen.nav" alt="">
            <img v-if="skin.imagen.mascot"
                 :src="skin.imagen.mascot" 
                 alt="" 
                 :class="['mascot', { 'mascot--hipicas': isHipicas }]" 
                 @click="change_view(skin.lobby ? 'sport' : 'lobby')"
            >
            <div class="d-flex" style="z-index: 5;position: relative;">
                <div v-for="item in categories" :key="item.category" @click="change_view(item.category)"
                    class="menu-text" style="width: 20%;display: flex;flex-direction: column;align-items: center;justify-content: space-around;">
                    <img v-if="item.category != 'lobby'" :src="item.icon1" style="width:20px;height:20px;margin-bottom: 4px;" >
                    <span :style="{ marginTop: item.category === 'lobby' ? '15px' : '0' }">{{ translate(item.name) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "bottom_navbar",
    props: ["skin", "translation", "language"],
    components: {},
    data() {
        return {
            categories: []
        }
    },
    computed: {
        user() {
            return this.$store.getters['getUserData'];
        },
        isHipicas() {
            return this.$store.getters['getInfoRouter']?.category === 'hipicas';
        }
    },
    methods: {
        async loadCategories() {
            if (this.skin.categories) {
                this.categories = this.skin.categories.filter(category =>
                    category.active &&
                    ["sport", "sportlive", "lobby", "casino", "casino_live"].includes(category.category)
                );
            }
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        change_view(view) {
            document.getElementById('closeSideBar')?.click();
            this.$store.dispatch("changeView", view);
        }
    },
    watch: {

    },
    async mounted() {
        await this.loadCategories();
    }
}
</script>

<style>
.fixed-bottom-custom {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 1000; /* asegúrate de que esté por encima */
}
.nav-img {
    width: 100%;
    position: absolute;
    bottom: 0px;
    z-index: 3;
}

.menu-text {
    font-family: "Roboto", Arial, sans-serif;
    font-size: .625rem;
    font-weight: 800;
    line-height: .625rem;
    color: #fff;
    text-transform: capitalize;
    text-align: center;
    padding: .313rem;
}

.menu-icon {
    width: 1.25rem;
    height: 1.25rem;
    margin-bottom: 5px;
}

.mascot {
    position: absolute;
    bottom: .75rem;
    left: 50%;
    width: 8rem;
    height: 8rem;
    z-index: 1;
    transform: translateX(-50%) scale(1);
    transform-origin: center bottom;
    transition: transform 320ms cubic-bezier(0.22, 1, 0.36, 1);
    will-change: transform;
}

.mascot--hipicas { 
    transform: translateX(-50%) scale(0.55);
}
</style>
